import { ThirdPartyPropertyIds, ThirdPartyScriptInstaller } from "./types";

interface UrlParams {
  [key: string]: string;
}

const paramsReplacer = (params: UrlParams) => (url: string, key: string) =>
  url.replace(new RegExp(`{${key}}`, "g"), params[key]);

const buildUrl = (url = "", params: UrlParams = {}): string =>
  Object.keys(params).reduce(paramsReplacer(params), url);

export const createScript = (src = "", params: UrlParams = {}) => {
  const tag = document.createElement("script");
  tag.async = true;
  tag.src = buildUrl(src, params);
  document.body.appendChild(tag);
};

export const thirdPartyScriptInstallerRunner = (
  tasks: ThirdPartyScriptInstaller["script"][],
  config: ThirdPartyPropertyIds
) => ({
  runCurrent: () => {
    window.requestIdleCallback(function(deadline) {
      const tasksCopy = [...tasks];

      while (tasksCopy.length && deadline.timeRemaining() > 0) {
        const task = tasksCopy.shift();
        if (typeof task !== "undefined") task(config);
      }

      if (tasksCopy.length) {
        requestIdleCallback(thirdPartyScriptInstallerRunner(tasksCopy, config).runCurrent);
      }
    });
  }
});
